import React, { useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaTachometerAlt, FaBox, FaShoppingCart, FaSignOutAlt, FaChartLine, FaWarehouse, FaTruck } from 'react-icons/fa';
import { UserContext } from '../App.js';

const SupplierSidebar = () => {
    // Get the user object from the context
    const { user, logout } = useContext(UserContext);
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    // Use optional chaining to safely get the last name
    const supplierName = user?.lastName || 'Fournisieur';

    return (
        <nav className="bg-gray-900 text-gray-300 w-64 min-h-screen p-6 flex flex-col shadow-xl">
            <div className="flex items-center justify-center mb-10">
                {/* Use the supplier's last name in the title */}
                <Link to="/supplier-dashboard" className="text-white text-3xl font-extrabold tracking-wide">
                    <span className="text-indigo-400">{supplierName}</span> Panel
                </Link>
            </div>
            <ul className="flex-grow space-y-3">
                <li>
                    <Link
                        to="/supplier-dashboard"
                        className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/supplier-dashboard')
                            ? 'bg-indigo-700 text-white font-bold'
                            : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'
                            }`}
                    >
                        <FaTachometerAlt className="w-5 h-5" />
                        <span className="font-medium">Tableau de bord</span>
                    </Link>
                </li>
                <li>
                    <Link
                        to="/supplier/products"
                        className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/supplier/products')
                            ? 'bg-indigo-700 text-white font-bold'
                            : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'
                            }`}
                    >
                        <FaBox className="w-5 h-5" />
                        <span className="font-medium">Mes Produits</span>
                    </Link>
                </li>
                <li>
                    <Link
                        to="/supplier/orders"
                        className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/supplier/orders')
                            ? 'bg-indigo-700 text-white font-bold'
                            : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'
                            }`}
                    >
                        <FaShoppingCart className="w-5 h-5" />
                        <span className="font-medium">Mes Commandes</span>
                    </Link>
                </li>

                <li>
                    <Link
                        to="/supplier/delivery"
                        className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/supplier/delivery')
                            ? 'bg-indigo-700 text-white font-bold'
                            : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'
                            }`}
                    >
                        <FaTruck className="w-5 h-5" />
                        <span className="font-medium">Mes Livreurs</span>
                    </Link>
                </li>
                <li>
                    <Link
                        to="/supplier/inventory"
                        className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/supplier/inventory')
                            ? 'bg-indigo-700 text-white font-bold'
                            : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'
                            }`}
                    >
                        <FaWarehouse className="w-5 h-5" />
                        <span className="font-medium">Les Inventaires</span>
                    </Link>
                </li>
                <li>
                    <Link
                        to="/supplier/analytics"
                        className={`flex items-center space-x-4 p-3 rounded-lg transition-colors duration-200 ${isActive('/supplier/analytics')
                            ? 'bg-indigo-700 text-white font-bold'
                            : 'text-gray-300 hover:bg-gray-800 hover:text-indigo-400'
                            }`}
                    >
                        <FaChartLine className="w-5 h-5" />
                        <span className="font-medium">Mes Analyses</span>
                    </Link>
                </li>
            </ul>
            <div className="mt-auto pt-4 border-t border-gray-700">
                <button
                    onClick={handleLogout}
                    className="w-full flex items-center space-x-4 p-3 rounded-lg text-red-400 hover:bg-red-900 transition-colors duration-200"
                >
                    <FaSignOutAlt className="w-5 h-5" />
                    <span className="font-medium">Déconnexion</span>
                </button>
            </div>
        </nav>
    );
};

export default SupplierSidebar;